// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachedFiles_root__25pNG","close":"AttachedFiles_close__3Ng9u","fileIcon":"AttachedFiles_fileIcon__3Q1BA","image":"AttachedFiles_image__2zxEL"};